<template>
  <div class="additional-information-container">
    <div class="right-header" :style="{ backgroundColor: color, color: textColor }">
      <span>Additional Information</span>
    </div>
    <div class="config">
      <slot name="content"></slot>
    </div>
  </div>
</template>

<script lang="ts" setup>
defineProps({
  color: {
    type: String,
    required: true,
  },
  textColor: {
    type: String,
    required: true,
  },
});
</script>

<style scoped lang="scss">
.right-header {
  position: absolute;
  width: calc(100% + 6rem);
  height: 100%;
  left: 100%;
  top: 0;
  padding-top: 0.25rem;

  border-radius: 0 5px 5px 0;
  box-shadow: 0 3px 8px 0 rgba(0, 0, 0, 0.1);

  span {
    margin-left: 5.5rem;
  }
}

.config {
  position: absolute;
  top: 2rem;
  left: calc(100% + 5rem);

  display: flex;
  flex-direction: column;
  flex: 1;

  background: white;
  border-radius: 5px;
  width: 100%;
  padding: 10px;
  box-shadow: 0 3px 8px 0 rgba(0, 0, 0, 0.1);
}
</style>
